import React from 'react'

function CustomButton({text,className,onClick, style ,...rest}) {
  return (
    <button style={style ? {
       width:'140px',
       maxWidth:'140px',
       minWidth:'140px',

    }:{}} className={className} onClick={()=>onClick(text)} {...rest}>{text}</button>
  )
}

export default CustomButton